import { CreateFileResponse } from '@/interfaces';

export const createFileResponseToFileEntity = (fileEntityUuid: string, response: CreateFileResponse) => {
  return {
    uuid: fileEntityUuid,
    id: response.id,
    display_name: response.display_name,
    url: response.url,
    thumbnail_url: response.urls?.thumbnail || null,
    medium_url: response.urls?.medium || null,
    print_a4_optimized_url: response.urls?.print_a4_optimized || null,
    size: response.size,
    size_bytes: response.size_bytes,
    extension: response.extension,
    name: response.name,
    notes: response.notes,
  };
};